/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Regenerated by `npm run cms:sync` from /api/cms/public/galleries.
 *
 * One entry per PUBLISHED gallery, in the server's display order. Each entry
 * carries only media UUIDs; URLs, sizes and alt text resolve through
 * `cmsMediaIndex`. `cmsGalleryBySlug` is the same rows keyed by slug, for the
 * detail page's build-time lookup — it is derived from `cmsGalleries` in the
 * writer so the two can never disagree.
 */

import type { GalleryEntry } from '@/content/gallery-types'

export type { GalleryEntry }

export const cmsGalleries: GalleryEntry[] = []

export const cmsGalleryBySlug: Record<string, GalleryEntry> = {}
